document.addEventListener('DOMContentLoaded', () => {
    const focusableElements = 'input, button, [href], select, textarea, [tabindex]:not([tabindex="-1"])';
    let lastFocusedElement;

    function trapFocus(event) {
       const dialog = document.querySelector('.em-popup-overlay.em-active > .em-popup');
       if (event.key !== 'Tab' || !dialog) return;

       const focusable = dialog.querySelectorAll(focusableElements);
       const first = focusable[0], last = focusable[focusable.length - 1];
       if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(), last.focus();
       } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(), first.focus();
       }
    }

    function unfocus(event) {
       const dialog = document.querySelector('.em-popup-overlay.em-active > .em-popup');
       if (!dialog) return;
       const focusable = Array.from(dialog.querySelectorAll(focusableElements));
       if (!focusable.includes(event.target)) {
          event.preventDefault();
          dialog.querySelector(focusableElements)?.focus();
       }
    }

    function lockScroll() {
       const scrollY = window.scrollY;
       Object.assign(document.body.style, {
          position: 'fixed',
          top: `-${scrollY}px`,
          left: '0',
          right: '0',
          width: '100%'
       });
       document.body.dataset.scrollY = scrollY;
    }

	function unlockScroll() {
		const scrollY = parseInt(document.body.dataset.scrollY || '0', 10);
		const html = document.documentElement;
		const prevScrollBehavior = html.style.scrollBehavior;
		html.style.scrollBehavior = 'auto';

		Object.assign(document.body.style, {
			position: '',
			top: '',
			left: '',
			right: '',
			width: ''
		});
		delete document.body.dataset.scrollY;

		window.scrollTo(0, scrollY);

		setTimeout(() => {
			html.style.scrollBehavior = prevScrollBehavior || '';
		}, 50);
	}

    function handleOpenPopup(popupOverlay) {
       if (!popupOverlay) return;

       popupOverlay.style.display = 'flex';
       setTimeout(() => popupOverlay.classList.add('em-active'), 10);

       lockScroll();

       popupOverlay.querySelectorAll('div:has(> iframe)').forEach(iframe => {
          iframe.setAttribute('tabindex', '0');
       });

       const first = popupOverlay.querySelector(focusableElements);
       if (first) {
          first.focus();
          popupOverlay.addEventListener('click', unfocus);
       }
       document.addEventListener('keydown', trapFocus);
    }

    function openPopup(trigger) {
       lastFocusedElement = document.activeElement;
       const popupId = trigger.getAttribute('em-popup-trigger-id');
       const popupOverlay = document.querySelector(`.em-popup-overlay[data-em-popup-id="${popupId}"]`);
       handleOpenPopup(popupOverlay);
    }

    function closePopup(popupId) {
       const popupOverlay = document.querySelector(`.em-popup-overlay[data-em-popup-id="${popupId}"]`);
       if (!popupOverlay) return;

       popupOverlay.classList.remove('em-active');
       setTimeout(() => popupOverlay.style.display = 'none', 400);
       popupOverlay.removeEventListener('click', unfocus);
       unlockScroll();
       document.removeEventListener('keydown', trapFocus);

       lastFocusedElement?.focus();
    }

    // Delegated click handler
    document.addEventListener('click', event => {
       // Popup trigger?
       const trigger = event.target.closest('[em-popup-trigger-id]');
       if (trigger) {
          event.preventDefault();
          openPopup(trigger);
          return;
       }

       // Close button inside popup?
       const closeBtn = event.target.closest('.em-popup-close');
       if (closeBtn) {
          event.preventDefault();
          const overlay = closeBtn.closest('.em-popup-overlay');
          if (overlay) closePopup(overlay.dataset.emPopupId);
          return;
       }

       // Click outside popup content?
       const overlay = event.target.closest('.em-popup-overlay');
       if (overlay && !event.target.closest('.em-popup')) {
          event.preventDefault();
          closePopup(overlay.dataset.emPopupId);
       }
    });

    // Escape-key support
    document.addEventListener('keydown', event => {
       if (event.key === 'Escape') {
          const active = document.querySelector('.em-popup-overlay.em-active');
          if (active) closePopup(active.dataset.emPopupId);
       }
    });
});
